import { useEffect } from 'react'

import useLeadVariant from './useLeadVariant'
import useFetchLeadByToken from './useFetchLeadByToken'
import usePostLead from './usePostLead'

import LeadHelper from '../helper'
import { useTransmissionContext } from 'modules/transmission/context/transmissionContext'
import { useLeadDataContext } from 'modules/lead/context/leadContext'

const useSetupLead = () => {
  const { transmissionData: { code }, transmissionCode } = useTransmissionContext()
  const {
    data: { name, email, userPlatformId, accepted, schedule, photo },
    showConfirm,
    isLoading,
    setData
  } = useLeadDataContext()
  const { leadVariant } = useLeadVariant()

  const fetchLeadByToken = useFetchLeadByToken()
  const postLead = usePostLead()

  useEffect(() => {
    fetchLeadByToken()
  }, [fetchLeadByToken])

  useEffect(() => {
    if (code && !isLoading && !showConfirm) {
      postLead({
        schedule: code,
        name,
        email,
        userPlatformId,
        accepted
      })
    }
  }, [code, name, email, userPlatformId, accepted, showConfirm, isLoading, postLead])

  useEffect(() => {
    const leadDataStorage = LeadHelper.getLeadDataLocalStorage()

    transmissionCode && leadDataStorage.schedule === transmissionCode && setData(leadDataStorage)
  }, [transmissionCode, setData])

  useEffect(() => {
    if (!name || !email || !schedule) {
      return
    }

    LeadHelper.setLeadDataLocalStorage({
      email,
      name,
      schedule,
      accepted,
      photo,
      userPlatformId
    })
  }, [email, name, schedule, accepted, photo, userPlatformId])

  return { leadVariant }
}

export default useSetupLead
